// Dependencies
import { Component } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';

import LoaderSpinner from 'components/atoms/LoaderSpinner';
import { bindActionCreators, Dispatch } from 'redux';
import { metOceanRecords } from 'services/metOcean';
import { SetErrorHandlerAction, setErrorHandlerAction } from 'store/actions/errorsActions';
import { SetMetOceanChartControlsAction, setMetOceanChartControlsAction } from 'store/actions/layoutActions';
import { PortType, PortURLType, RootState, TransitType } from 'types';
import { CreateTransitChartInterface } from 'types/functions';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

import MetOceanChart from './MetOceanChart';

interface MetOceanComponentProps {
    active: boolean;
    opendMenu?: boolean;

    port: PortType;
    setMetOceanControlsAction: SetMetOceanChartControlsAction;
    setErrorHandlerAction: SetErrorHandlerAction;
    dateTimeFormat: DateTimeFormat;
}

interface MetOceanComponentState {
    active: boolean;
    opendMenu?: boolean;

    environmentalSources: PortURLType[] | undefined;
    transit: TransitType | null;
    time: DateTimeFormat | null;
    type: string | null;
    loading: boolean;
    port: PortType;
    results: any[];
}

class MetOcean extends Component<MetOceanComponentProps, MetOceanComponentState> {
    constructor(props: MetOceanComponentProps) {
        super(props);
        this.state = {
            transit: null,
            time: null,
            loading: false,
            type: null,
            active: false,
            opendMenu: false,
            port: props.port,

            environmentalSources: props.port.port_urls?.filter((x) => {
                return x.type === 'environmental';
            }),
            results: [],
        };
    }

    static getDerivedStateFromProps(props: MetOceanComponentProps, state: MetOceanComponentState) {
        if (props.active !== state.active || props.opendMenu !== state.opendMenu) {
            return { active: props.active, opendMenu: props.opendMenu };
        }

        return null;
    }

    componentDidMount(): void {
        this.props.setMetOceanControlsAction({
            createTransitChart: this.createTransitChart,
        });
    }

    createTransitChart: CreateTransitChartInterface = (type: string, transit: TransitType, time: DateTimeFormat) => {
        this.setState(
            {
                type,
                transit,
                time,
            },
            this.getChartData
        );
    };

    getChartData = () => {
        if (!this.state.transit || !this.state.environmentalSources) {
            return;
        }

        this.setState(
            {
                loading: true,
                results: [],
            },
            () => {
                metOceanRecords(this.props.port.id, {
                    type: this.state.type,
                    //@ts-ignore
                    port_url_id: this.state.environmentalSources
                        .filter((item) => {
                            return item.environmental_type === this.state.type;
                        })
                        .map((item) => {
                            return item.id;
                        }),
                    //@ts-ignore
                    transit: this.state.transit.id,
                })
                    .then((res) => {
                        this.setState({
                            loading: false,
                            //@ts-ignore
                            results: res.items,
                        });
                    })
                    .catch((errors) => {
                        this.props.setErrorHandlerAction(errors);
                    });
            }
        );
    };

    render() {
        return (
            <div
                className={twclsx(
                    !this.state.active && 'hidden',
                    'mt-14',
                    'h-page',
                    'border-l',
                    'border-gray-300',
                    'padding-transition',
                    'fixed',
                    'z-20',
                    'left-0',
                    'right-0',
                    'margin-transition',
                    'bg-white',
                    this.state.opendMenu ? 'ml-menu w-main' : 'ml-14 w-fullPage'
                )}
            >
                <div className="p-2 h-10  first-letter-uppercase   border-b border-gray-300 ">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: translate('metocean chart title', {
                                type: this.state.type,
                                vesselName: this.state.transit?.vessel.name,
                                startTime:
                                    this.state.transit?.start_utc.formatDateTimeToString('dd LLL yyyy HH:mm:ss Z'),
                                endTime: this.state.transit?.end_utc.formatDateTimeToString('dd LLL yyyy HH:mm:ss Z'),
                            }),
                        }}
                    ></div>
                </div>

                <div className="relative">
                    {this.state.loading ? (
                        <LoaderSpinner variant="table"></LoaderSpinner>
                    ) : (
                        <Scrollbars
                            renderThumbHorizontal={() => <div style={{ display: 'none' }} />}
                            renderTrackHorizontal={() => <div style={{ display: 'none' }} />}
                            style={{
                                height: 'calc( 100vh - 110px)',
                            }}
                        >
                            <MetOceanChart
                                time={this.state.time}
                                type={this.state.type}
                                transit={this.state.transit}
                                data={this.state.results}
                            />
                        </Scrollbars>
                    )}
                </div>
            </div>
        );
    }
}

const MetOceanStateToProps = (state: RootState) => ({
    dateTimeFormat: state.port.dateTimeFormat,
    port: state.port.port,
});

const MetOceanDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
    setMetOceanControlsAction: bindActionCreators(setMetOceanChartControlsAction, dispatch),
});

export default connect(MetOceanStateToProps, MetOceanDispatchToProps)(MetOcean);
